class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    const currentState =
      clickedTriggerEl.getAttribute('aria-expanded') === 'true'

    this.els.trigger.elements.forEach((triggerEl) => {
      if (
        triggerEl.getAttribute('aria-controls') ===
        clickedTriggerEl.getAttribute('aria-controls')
      ) {
        triggerEl.setAttribute('aria-expanded', !currentState)
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.setAttribute('aria-expanded', false)
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        contentEl.setAttribute('aria-hidden', currentState)
      } else if (this.dataset.type === 'oneopen') {
        contentEl.setAttribute('aria-hidden', true)
      }
    })
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
